const Service = (type) => {
	let parsed = null;

	switch (type) {
		case "TEST": {
			parsed = { type: "GET", url: "/doug_task/" };
			break;
		}

		default:
			break;
	}

	return parsed;
};

export default Service;
